import { Slide, Snackbar } from '@mui/material'
import { useAppStore } from '../store/useAppStore'

const CustomSnackbar = () => {
  const snackbar = useAppStore((state) => state.snackbar)
  const setSnackbar = useAppStore((state) => state.setSnackbar)

  const handleSnackbarClose = () => setSnackbar({ ...snackbar, open: false })

  return (
    <Snackbar
      open={snackbar.open}
      TransitionComponent={Slide}
      autoHideDuration={3000}
      onClose={handleSnackbarClose}
      message={snackbar.message}
    />
  )
}

export default CustomSnackbar
